import React from "react"
import "./layout.css"  // old way for global CSS
import { useStaticQuery, Link, graphql } from "gatsby"

import {rhythm, scale} from "../utils/typography"
import Image from "gatsby-image";

const ListLink = props => (
    <li style={{display: `inline-block`, marginRight: `1rem`}}>
        <Link to={props.to}>{props.children}</Link>
    </li>
)

const Layout = ({location, children}) => {
    const rootPath = `${__PATH_PREFIX__}/`
    let header
    console.log(`location: ${location.pathname}`)

    // const data = useStaticQuery(
    //     graphql`
    //   query {
    //     site {
    //       siteMetadata {
    //         title
    //       }
    //     }
    //   }
    // `)
    const data = useStaticQuery(graphql`
    query LayoutQuery {
      avatar: file(absolutePath: { regex: "/munggoggo.png/" }) {
        childImageSharp {
          fixed(width: 50, height: 50) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          title
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

    if (location.pathname === rootPath) {
        const {author} = data.site.siteMetadata
        header = (
            <h1
                style={{
                    ...scale(1.5),
                    marginBottom: rhythm(1.5),
                    marginTop: 0,
                    display: `inline`,
                    color: '#52678a',
                }}
            >
                <Image
                    fixed={data.avatar.childImageSharp.fixed}
                    alt={author.name}
                    style={{
                        marginRight: rhythm(1 / 2),
                        marginBottom: 0,
                        minWidth: 50,
                        borderRadius: `100%`,
                    }}
                    imgStyle={{
                        borderRadius: `50%`,
                    }}
                />
                <Link
                    style={{
                        ...scale(1.5),
                        marginBottom: rhythm(1.5),
                        boxShadow: `none`,
                        textDecoration: `none`,
                        color: `inherit`,
                    }}
                    to={`/`}
                >
                    {data.site.siteMetadata.title}
                </Link>
            </h1>
        )
    } else {
        header = (
            <h3
                style={{
                    fontFamily: `Montserrat, sans-serif`,
                    marginTop: 0,
                    display: `inline`,
                    color: '#52678a',
                }}
            >
                <Link
                    style={{
                        boxShadow: `none`,
                        textDecoration: `none`,
                        color: `inherit`,
                    }}
                    to={`/`}
                >
                    {data.site.siteMetadata.title}
                </Link>
            </h3>
        )
    }
    return (
        <div
            style={{
                marginLeft: `auto`,
                marginRight: `auto`,
                maxWidth: rhythm(40),
                padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
            }}
        >
            <div style={{marginBottom: rhythm(3),}}>
                <header>
                    {header}
                    <ul style={{listStyle: `none`, float: `right`}}>
                        <ListLink to="/">Home</ListLink>
                        {/*<ListLink to="/about/">About</ListLink>*/}
                        <ListLink to="/hello-world/">About</ListLink>
                        <ListLink to="/contact/">Contact</ListLink>
                    </ul>
                </header>

            </div>
            <main>{children}</main>
            <footer>
                © {new Date().getFullYear()}, sysid
            </footer>
        </div>
    )
}

export default Layout
